module.exports = __webpack_public_path__ + "static/media/approved-green.0ec1cafe.svg";